import { Box, Card, Grid, Stack, Typography } from '@mui/material';

const PartnerDonutChart = ({ data, formatNumber }) => {
  const rawTotal = data.reduce((sum, item) => sum + item.value, 0);
  const total = rawTotal || 1;
  const hasData = rawTotal > 0;
  let current = 0;
  const gradientStops = data
    .map((item) => {
      const start = current;
      current += (item.value / total) * 100;
      return `${item.color} ${start}% ${current}%`;
    })
    .join(', ');

  return (
    <Grid container rowSpacing={3} alignItems="center">
      <Grid item xs={12} md={5}>
        <Box
          sx={{
            width: { xs: 220, md: 240 },
            height: { xs: 220, md: 240 },
            borderRadius: '50%',
            background: hasData
              ? `conic-gradient(${gradientStops})`
              : 'conic-gradient(rgba(148, 163, 184, 0.22) 0% 100%)',
            position: 'relative',
            mx: 'auto'
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              inset: 28,
              borderRadius: '50%',
              background: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              px: 2
            }}
          >
            <Stack spacing={0.5}>
              <Typography variant="caption" color="text.secondary">
                Total Transactions
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 800 }}>
                {formatNumber(rawTotal)}
              </Typography>
            </Stack>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={7}>
        <Stack spacing={1.5}>
          {data.map((item) => {
            const percentage = ((item.value / total) * 100).toFixed(1);
            return (
              <Card key={item.label} variant="outlined" sx={{ borderRadius: 1, boxShadow: 'none' }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 1.5 }}>
                  <Stack direction="row" spacing={1.25} alignItems="center">
                    <Box
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: 999,
                        backgroundColor: item.color
                      }}
                    />
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {item.label}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={1.5}>
                    <Typography variant="body2" color="text.secondary">
                      {percentage}%
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                      {formatNumber(item.value)}
                    </Typography>
                  </Stack>
                </Stack>
              </Card>
            );
          })}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default PartnerDonutChart;
